import PropTypes from 'prop-types';
import { FB_COLORS, FB_LABELS, pastelize } from '../calendar/eventStyle.js';

/**
 * Availability key for the calendar grids.
 *
 * The status used to live only in an event's hover tooltip: reading a grid
 * meant hovering block after block. The legend states the five codes once,
 * "Inconnu" included — a window the server will not describe is not a free
 * window, and it must not read as one.
 *
 * Sits under the grid rather than over it, so it never covers the last row.
 */

const STATES = [
  { code: 'F' },
  { code: 'T', outlined: true },
  { code: 'B' },
  { code: 'O' },
  { code: 'N', hatched: true },
];

export default function PlanningLegend() {
  return (
    <div className="flex shrink-0 flex-wrap items-center gap-x-4 gap-y-1 border-t border-gray-200 bg-white px-4 py-1.5 text-xs text-gray-600">
      <span className="font-medium text-gray-500">Disponibilité</span>
      {STATES.map((state) => (
        <span key={state.code} className="flex items-center gap-1.5">
          <Swatch state={state} />
          {FB_LABELS[state.code]}
        </span>
      ))}
    </div>
  );
}

function Swatch({ state }) {
  const color = FB_COLORS[state.code];
  if (state.outlined) {
    return (
      <span
        aria-hidden="true"
        className="inline-block h-2.5 w-4 rounded-sm border-2 border-dashed bg-transparent"
        style={{ borderColor: color }}
      />
    );
  }
  return (
    <span
      aria-hidden="true"
      className={`inline-block h-2.5 w-4 rounded-sm border ${state.hatched ? 'planif-fb-nodata border-dashed' : ''}`}
      style={{ backgroundColor: pastelize(color), borderColor: color }}
    />
  );
}

Swatch.propTypes = {
  state: PropTypes.shape({
    code: PropTypes.string.isRequired,
    outlined: PropTypes.bool,
    hatched: PropTypes.bool,
  }).isRequired,
};
